import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const ConfirmationDialog = ({
  cancelButtonText,
  confirmButtonText,
  confirmationButtonVariant,
  description,
  onConfirm,
  onOpenChange,
  open,
  preventContentClickPropagation,
  preventOverlayClickCapturePropagation,
  title,
}: {
  cancelButtonText?: string;
  confirmButtonText?: string;
  confirmationButtonVariant?: "default" | "destructive";
  description: string;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  preventContentClickPropagation?: boolean;
  preventOverlayClickCapturePropagation?: boolean;
  title: string;
}) => {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent
        className="flex flex-col gap-10"
        onClick={
          preventContentClickPropagation
            ? (e) => {
                e.stopPropagation();
              }
            : undefined
        }
        preventOverlayClickCapturePropagation={
          preventOverlayClickCapturePropagation
        }
      >
        <DialogHeader className="flex flex-col gap-4">
          <DialogTitle className="text-2xl font-semibold text-slate-700">
            {title}
          </DialogTitle>
          <DialogDescription className="!m-0 text-base font-medium text-slate-700">
            {description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            className="rounded-full"
            onClick={() => {
              onOpenChange(false);
            }}
            variant="secondary"
          >
            {cancelButtonText ?? "Cancel"}
          </Button>
          <Button
            className="rounded-full"
            onClick={onConfirm}
            variant={confirmationButtonVariant}
          >
            {confirmButtonText ?? "Confirm"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
